module.exports = __webpack_public_path__ + "img/vihc.79b19311.jpg";